import { useEffect } from 'react';

export const useChangeURLLanguageSearchParams = (urlSearchParams, i18n, history) => {
  useEffect(() => {
    if (urlSearchParams.has('lang') && i18n.language !== urlSearchParams.get('lang')) {
      urlSearchParams.set('lang', i18n.language);
      history.replace(`${history.location.pathname}?${urlSearchParams.toString()}`);
    }
  }, [history, i18n.language, urlSearchParams]);
};
